class QuizModal extends HTMLElement {
  constructor() {
    super();
    this.currentStep = 1;
    this.answers = {};
    this.results = [];
  }

  connectedCallback() {
    this.init();
    this.setupBackdropListener();
    this.checkAutoOpen();
  }

  checkAutoOpen() {
    const modalDialog = this.closest("modal-dialog");
    if (!modalDialog) return;

    const key = `quiz-modal-seen-${this.dataset.quizId}`;
    const hasSeenQuiz = localStorage.getItem(key);
    
    if (!hasSeenQuiz) {
      setTimeout(() => {
        modalDialog.show();
        localStorage.setItem(`quiz-modal-seen-${this.dataset.quizId}`, "true");
      }, 3000);
    }
  }

  setupBackdropListener() {
    const modalDialog = this.closest('modal-dialog');
    if (!modalDialog) return;

    modalDialog.addEventListener('click', (e) => {
      if (e.target === modalDialog) {
        this.restartQuiz();
        setTimeout(() => {
          if (modalDialog.hide) {
            modalDialog.hide();
          }
        }, 100);
      }
    });

    const closeButton = this.querySelector('#ModalClose-Quiz');
    if (closeButton) {
      closeButton.addEventListener('click', (e) => {
        e.stopPropagation();
        this.restartQuiz();
        setTimeout(() => {
          if (modalDialog.hide) {
            modalDialog.hide();
          }
        }, 100);
      });
    }
  }

  init() {
    const stepsContainer = this.querySelector(".quiz-steps");
    if (stepsContainer) {
      const questionSteps = this.querySelectorAll(".quiz-step:not(.quiz-result)");
      this.totalSteps = questionSteps.length;
    }

    const options = this.dataset.quizOptions;

    if (options) {
      try {
        const parsedData = JSON.parse(options);
        this.results = parsedData.results;
      } catch (e) {
        console.error("Failed to parse quiz data:", e);
      }
    }

    this.querySelectorAll(".quiz-option").forEach(answer => {
      answer.addEventListener("click", (e) => this.handleOptionClick(e));
    });
    
    const restartButton = this.querySelector(".quiz-restart");
    if (restartButton) {
      restartButton.addEventListener("click", () => this.restartQuiz());
    }
  }

  handleOptionClick(event) {
    event.preventDefault();
    event.stopPropagation();
    
    const button = event.target;
    const questionNumber = button.dataset.question;
    const answerText = button.dataset.value;
    const resultScent = button.dataset.result;
    
    this.answers[questionNumber] = {
      text: answerText,
      result: resultScent
    };
    
    if (this.currentStep < this.totalSteps) {
      this.nextStep();
    } else {
      this.showResult();
    }
  }

  nextStep() {
    const currentStepEl = this.querySelector(`.quiz-step[data-step="${this.currentStep}"]`);
    const nextStepEl = this.querySelector(`.quiz-step[data-step="${this.currentStep + 1}"]`);
    
    if (currentStepEl && nextStepEl) {
      currentStepEl.classList.remove("active");
      nextStepEl.classList.add("active");
      this.currentStep++;
    }
  }

  showResult() {
    const resultStep = this.querySelector(".quiz-result");
    const currentStep = this.querySelector(`.quiz-step[data-step="${this.currentStep}"]`);
    
    if (resultStep && currentStep) {
      currentStep.classList.remove("active");
      resultStep.classList.add("active");

      const matchedResult = this.findMatchingCollection();
      
      this.renderCollectionLink(matchedResult);
    }
  }

  findMatchingCollection() {
    const scores = {};
    this.results.forEach(result => {
      scores[result.result_scent] = 0;
    });

    for (const [questionNum, answerData] of Object.entries(this.answers)) {
      const targetResult = answerData.result;
      scores[targetResult] += 1;
    }

    let maxScore = -1;
    let winningResultScent;

    for (const [resultScent, score] of Object.entries(scores)) {
      if (score > maxScore) {
        maxScore = score;
        winningResultScent = resultScent;
      }
    }

    return this.results.find(r => r.result_scent === winningResultScent);
  }

  renderCollectionLink(result) {
    if (!result) return;
    const resultStep = this.querySelector(".quiz-result");
    const resultDiscountWrapper = this.querySelector(".result-discount-wrapper");

    if (resultDiscountWrapper) {
      const resultScent = `<p class="result-scent result-discount-block"> ${result.result_scent} </p>`;
      resultDiscountWrapper.insertAdjacentHTML('afterbegin', resultScent);
    }

    const buttonsWrapper = resultStep?.querySelector(".buttons-wrapper");
    if (buttonsWrapper) {
      const collectionLink = `<a href="${result.collection_url}" class="button quiz-collection-link">Zobacz całą kolekcję</a>`;
      buttonsWrapper.insertAdjacentHTML('afterbegin', collectionLink);
    }
  }

  restartQuiz() {
    const currentActiveSteps = this.querySelectorAll(`.quiz-step.active`);
    if (currentActiveSteps) {
      currentActiveSteps.forEach((activeStep) => {
        activeStep.classList.remove("active");
      });
    }

    const resultScent = this.querySelector(".result-scent");
    if (resultScent) {
      resultScent.remove();
    }

    const collectionLink = this.querySelector(".quiz-collection-link");
    if (collectionLink) {
      collectionLink.remove();
    }
    
    this.currentStep = 1;
    this.answers = {};
    
    const firstStep = this.querySelector(".quiz-step[data-step='1']");
    if (firstStep) {
      firstStep.classList.add("active");
    }
  }
}

customElements.define("quiz-modal", QuizModal);